// extracted by mini-css-extract-plugin
export default {"customer_wraper":"style_customer_wraper__M+2+O","customer":"style_customer__rmw7d","customer_lootie":"style_customer_lootie__ZkcEy","customer_name":"style_customer_name__KypUZ"};